"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDownloadCSV = void 0;
var dsl_schema_ui_1 = require("@newfront-insurance/dsl-schema-ui");
var json2csv_1 = require("json2csv");
var get_1 = __importDefault(require("lodash/get"));
var react_1 = require("react");
function useDownloadCSV(_a) {
    var schema = _a.schema;
    var parser = (0, react_1.useMemo)(function () {
        var _a;
        var columns = ((_a = schema.spreadsheet) === null || _a === void 0 ? void 0 : _a.columns) || [];
        return new json2csv_1.Parser({
            fields: columns.map(function (column) {
                var _a, _b;
                var schemaProperty = (0, get_1.default)(schema, (0, dsl_schema_ui_1.getNestedFieldNameSchemaProperty)(column.fieldName));
                return {
                    label: ((_b = (_a = schemaProperty.inputMetadata) === null || _a === void 0 ? void 0 : _a.label) === null || _b === void 0 ? void 0 : _b.replace('#', '')) || 'No label',
                    value: function (row, _field) {
                        return (0, dsl_schema_ui_1.getStringifiedFieldValue)((0, get_1.default)(row.data || {}, column.fieldName), schemaProperty);
                    },
                };
            }),
        });
    }, [schema]);
    function handleDownload(data, filename) {
        var csv = parser.parse(data);
        var blob = new Blob([csv], { type: 'text/csv' });
        var csvUrl = URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.setAttribute('href', csvUrl);
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
    }
    return {
        download: handleDownload,
    };
}
exports.useDownloadCSV = useDownloadCSV;
